import React from 'react';
import { Badge, Button } from 'antd';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import styles from './UserCreditRequestNotification.module.scss';
import JobUsageBudgetApprovedIcon from '../../../Icons/JobUsageBudgetApprovedIcon';
import JobUsageBudgetDismissedIcon from '../../../Icons/JobUsageBudgetDismissedIcon';
import messages from '../../../Containers/ManualSearchV2/ManualSearchMessages';

export default function UserCreditRequestNotification(props) {
  const { notification, onClick, featureToggleList } = props;
  const isUserBudgetFeatureEnabled = featureToggleList.UserBudgetCapping.IsEnabled;
  const { Payload: payload, UpdatedTime: updatedTime, UnreadCount: unreadCount } = notification;
  const { RequestStatus: requestStatus } = payload;

  const status = (
    <b>
      <FormattedMessage {...messages[requestStatus]} />
    </b>
  );

  const notificationTitle = <FormattedMessage {...messages.userCreditRequestStatus} values={{ Status: status }} />;

  return isUserBudgetFeatureEnabled ? (
    <div className={styles.notification} role="presentation" onClick={() => onClick(notification)}>
      <div className={styles.AcceptedIcon}>
        {requestStatus === 'Approved' ? <JobUsageBudgetApprovedIcon /> : <JobUsageBudgetDismissedIcon />}
      </div>
      <div className={styles.content}>
        <div className={styles.notificationTitle}>{notificationTitle}</div>
        <div className={styles.message}>
          {requestStatus === 'Approved' ? (
            <FormattedMessage {...messages.creditRequestApprovedMessage} />
          ) : (
            <FormattedMessage {...messages.creditRequestDeclinedMessage} />
          )}
        </div>
        <div className={styles.time}>{moment.utc(updatedTime).local().fromNow()}</div>
      </div>
      <div className={styles.viewSymbol}>
        <Badge dot={unreadCount > 0} />
      </div>
    </div>
  ) : null;
}
